class ArticleSlider {
  constructor(container) {
    this.container = container;
    this.prevButton = container.querySelector('.slider-button--prev');
    this.nextButton = container.querySelector('.slider-button--next');
    this.isRecentArticles = container.closest('.recent-articles') !== null;
    
    // Different selection logic for different sections
    if (this.isRecentArticles) {
      this.articles = Array.from(this.container.querySelectorAll('.article-card'));
    } else {
      this.articles = Array.from(this.container.querySelectorAll('.article-item, .article-card'));
    }
    
    this.itemsToShow = parseInt(container.dataset.itemsToShow) || 3;
    this.totalItems = this.articles.length;
    this.currentIndex = 0;
    
    // Pagination bullets
    this.paginationBullets = Array.from(this.container.querySelectorAll('.slider-pagination-bullet'));
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.slideNext());
    }
    
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.slidePrev());
      // Initially hide prev button
      this.prevButton.style.display = 'none';
    }
    
    // Set up pagination bullet click events
    this.paginationBullets.forEach(bullet => {
      bullet.addEventListener('click', () => {
        const slideIndex = parseInt(bullet.dataset.index);
        this.goToSlide(slideIndex);
      });
    });
    
    // Initial setup
    this.updateVisibleArticles();
  }

  goToSlide(index) {
    // For mobile view we show one slide at a time
    this.currentIndex = index;
    this.updateVisibleArticles();
    this.updateButtonVisibility();
    this.updatePaginationBullets();
  }

  slideNext() {
    // Calculate next position
    const nextIndex = this.currentIndex + this.itemsToShow;
    
    // If we're at the end, loop back to start
    if (nextIndex >= this.totalItems) {
      this.currentIndex = 0;
    } else {
      this.currentIndex = nextIndex;
    }
    
    this.updateVisibleArticles();
    this.updateButtonVisibility();
    this.updatePaginationBullets();
  }
  
  slidePrev() {
    // Calculate previous position
    const prevIndex = this.currentIndex - this.itemsToShow;
    
    // If we're at the start, loop to end
    if (prevIndex < 0) {
      // Go to the last complete set
      const lastSetIndex = Math.floor((this.totalItems - 1) / this.itemsToShow) * this.itemsToShow;
      this.currentIndex = lastSetIndex;
    } else {
      this.currentIndex = prevIndex;
    }
    
    this.updateVisibleArticles();
    this.updateButtonVisibility();
    this.updatePaginationBullets();
  }
  
  updateVisibleArticles() {
    const isMobile = window.innerWidth <= 749;
    
    // Skip controlling visibility for recent articles on mobile
    if (this.isRecentArticles && isMobile) {
      return;
    }
    
    // For desktop or other sections
    if (this.isRecentArticles) {
      // For recent articles section on desktop
      this.articles.forEach((article, index) => {
        if (index >= this.currentIndex && index < this.currentIndex + this.itemsToShow) {
          article.classList.remove('desktop-hidden');
        } else {
          article.classList.add('desktop-hidden');
        }
      });
    } else {
      // For other sections
      // Hide all articles
      this.articles.forEach(article => article.classList.add('hidden'));
      
      // Check if we're on mobile
      const itemsToShow = isMobile ? 1 : this.itemsToShow;
      
      // Show only current batch
      for (let i = this.currentIndex; i < this.currentIndex + itemsToShow && i < this.totalItems; i++) {
        this.articles[i].classList.remove('hidden');
      }
    }
  }
  
  updatePaginationBullets() {
    if (this.paginationBullets.length === 0) return;
    
    // Remove active class from all bullets
    this.paginationBullets.forEach(bullet => {
      bullet.classList.remove('active');
    });
    
    // Add active class to current bullet
    const activeBulletIndex = Math.floor(this.currentIndex / 1);
    if (this.paginationBullets[activeBulletIndex]) {
      this.paginationBullets[activeBulletIndex].classList.add('active');
    }
  }
  
  updateButtonVisibility() {
    if (this.totalPages <= 1 || window.innerWidth <= 749) {
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.nextButton) this.nextButton.style.display = 'none';
      return;
    }
    
    if (this.prevButton) {
      this.prevButton.style.display = this.currentIndex === 0 ? 'none' : 'flex';
    }
    
    if (this.nextButton) {
      const lastVisibleIndex = this.currentIndex + this.itemsToShow;
      this.nextButton.style.display = lastVisibleIndex >= this.totalItems ? 'none' : 'flex';
    }
  }
  
  get totalPages() {
    return Math.ceil(this.totalItems / this.itemsToShow);
  }
}

// Initialize all sliders when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.selected-articles__slider, .recent-articles__slider');
  sliders.forEach(slider => {
    const articleSlider = new ArticleSlider(slider);
    
    // Handle resize events to adjust for mobile/desktop view
    window.addEventListener('resize', () => {
      articleSlider.updateVisibleArticles();
      articleSlider.updateButtonVisibility();
      articleSlider.updatePaginationBullets();
    });
  });
}); 